import breadcrumbs from './Employee_study_breadcrumbs';
import modal from './Employee_study_modal';
import directorate from './Employee_study_directorate';
import organizations from './Employee_study_organizations';
import users from './Employee_study_users';
import courses from './Employee_study_courses';
import coursesSummary from './Employee_study_courses_summary';
import coursesBusinessPlusSummary from './Employee_study_courses_business_plus_summary';
import coursesVerification from './Employee_study_courses_verification';
import api from '../../api/index';
import i18n from '../../i18n';

export default {
  namespaced: true,
  modules   : {
    breadcrumbs,
    modal,
    directorate,
    organizations,
    users,
    courses,
    coursesSummary,
    coursesBusinessPlusSummary,
    coursesVerification,
  },
  state: {
    modals: [
      {
        type  : 'course_stat_modal',
        active: false,
      },
      {
        type  : 'employee_study_modal',
        active: false,
      },
    ],
    permission: {
      users    : [985, 172, 173],
      location : [985, 172, 173],
      control  : [985],
      date     : [985, 172, 173, 168, 169, 170, 171],
      groups   : [985, 172, 173],
      employees: [985, 172, 173, 168, 169],
      courses  : [985, 172, 173, 168, 169, 170, 171],
    },
    tab        : 'directorate',
    search     : '',
    total_stats: {
      all_course_count                : 0,
      new_course_count                : 0,
      completed_course_count          : 0,
      current_course_count            : 0,
      expired_course_history_count    : 0,
      not_expired_course_history_count: 0,
      courses_verification            : 0,
      tab_count                       : {},
    },
    export_url        : '',
    export_loading    : false,
    current_department: {},
    current_company   : {},
    current_user      : 0,
    current_course    : 0,
  },
  getters: {
    tab                 : ({tab}) => tab,
    current_department  : ({current_department}) => current_department,
    current_company     : ({current_company}) => current_company,
    current_user        : ({current_user}) => current_user,
    current_course      : ({current_course}) => current_course,
    total_stats         : ({total_stats}) => total_stats,
    export_url          : ({export_url}) => export_url,
    export_loading      : ({export_loading}) => export_loading,
    course_stat_modal   : ({modals}) => modals.find((modal) => modal.type == 'course_stat_modal'),
    employee_study_modal: ({modals}) => modals.find((modal) => modal.type == 'employee_study_modal'),
    get_region_by_name  : ({total_stats}) => (name) => {
      return total_stats.filter_regions.find((region) => region.text === name);
    },
    get_cities_by_region_id: ({total_stats}) => (id = '') => {
      let cities = total_stats.filter_cities.map((city) => {
        return city.region === id ? city : false;
      }).filter((i) => i);

      if (!!cities.length) {
        cities.unshift({id: 0, text: '-'});
      } else {
        cities = [{text: i18n.t('Все города'), id: 0}];
      }

      return cities;
    },
    get_all_permissions: (state, getters, rootState) => (id) => {
      let permission = {};

      if (!id) {
        id = JSON.parse(localStorage.getItem('user')).role_id;
      }

      for (let [key, value] of Object.entries(state.permission)) {
        permission[key] = value.includes(id);
      }

      return permission;
    },
  },
  mutations: {
    CLOSE_MODAL(state, type) {
      let modal = state.modals.find((modal) => modal.type === type);
      modal.active = false;
    },
    OPEN_MODAL(state, type) {
      let modal = state.modals.find((modal) => modal.type === type);
      if (!modal.active) {
        modal.active = true;
      }
    },
    SET_TOTAL_TABS(state, {key, value}) {
      state.total_stats.tab_count[key] = value;
    },
    SET_ACTIVE_TAB(state, value) {
      state.tab = value;
    },
    SET_SEARCH_GENERAL(state, value) {
      state.search = value;
    },
    SET_TOTAL_STATS(state, value) {
      state.total_stats = value;
    },
    SET_EXPORT(state, value) {
      state.export_url = value;
    },
    SET_EXPORT_LOADING(state, value) {
      state.export_loading = value;
    },
    SET_CURRENT_DEPARTMENT(state, value) {
      state.current_department = value;
    },
    SET_CURRENT_COMPANY(state, value) {
      state.current_company = value;
    },
    SET_CURRENT_USER(state, value) {
      state.current_user = value;
    },
    SET_CURRENT_COURSE(state, value) {
      state.current_course = value;
    },
  },
  actions: {
    async get_total_stats({commit}) {
      try {
        const get_stats = await api.learning.get_total();
        commit('SET_TOTAL_STATS', get_stats.data);
      } catch (err) {
        console.error(err);
      }
    },
    async get_business_plus_total_stats({commit}) {
      try {
          const get_total_business_plus = await api.learning.get_total_business_plus();
          commit('SET_TOTAL_STATS', get_total_business_plus.data);
      } catch (err) {
          console.error(err);
      }
    },
    async get_organizations({commit}, filter) {
      let learning = await api.learning.get_organizations(filter);
      commit('employee_study/directorate/SET_COMPANIES', learning.data, {root: true});
      commit('SET_TOTAL_TABS', {key: 'departments', value: learning.data.length});
    },
    async get_companies({commit}, {filter, page = 1, perPage = 10, makeExport = true}) {
      let learning = await api.learning.get_companies(filter, page, perPage);
      const companies = learning.data.data.map((item) => {
        item.name = decodeURIComponent(item.name);
        return item;
      });

      await commit('employee_study/organizations/SET_ORG', companies, {root: true});
      commit('employee_study/organizations/SET_PAGINATION', learning.data.pagination, {root: true});
      commit('SET_TOTAL_TABS', {key: 'companies', value: learning.data.pagination.total});
    },
    async get_users({commit}, {filter, page = 1, perPage = 10, makeExport = true}) {
      let learning = await api.learning.get_users(filter, page, perPage);

      await commit('employee_study/users/SET_USERS', learning.data.data, {root: true});
      commit('employee_study/users/SET_PAGINATION', learning.data.pagination, {root: true});
      commit('SET_TOTAL_TABS', {key: 'users', value: learning.data.pagination.total});
    },
    async get_courses({commit}, filter) {
      let learning = await api.learning.get_courses(filter);
      commit('employee_study/courses/SET_COURSES', learning.data, {root: true});
      commit('SET_TOTAL_TABS', {key: 'courses', value: learning.data.length});
    },

    async get_courses_summary({commit}, {filter, page = 1, perPage = 10}) {
      let learning = await api.learning.get_courses_summary(filter, page, perPage);
      commit('employee_study/coursesSummary/SET_COURSES_SUMMARY', learning.data, {root: true});
      commit('employee_study/coursesSummary/SET_COURSES_SUMMARY_HEADERS', learning.data.courses, {root: true});
      commit('employee_study/coursesSummary/SET_COURSES_SUMMARY_PAGINATION', learning.data.pagination, {root: true});
      commit('SET_TOTAL_TABS', {key: 'courses_summary', value: learning.data.pagination.total});
    },

    async get_courses_business_plus_summary({commit}, {filter, page = 1, perPage = 10}) {
      let learning = await api.learning.get_courses_business_plus_summary(filter, page, perPage);
      commit('employee_study/coursesBusinessPlusSummary/SET_COURSES_BUSINESS_PLUS_SUMMARY', learning.data, {root: true});
      commit('employee_study/coursesBusinessPlusSummary/SET_COURSES_BUSINESS_PLUS_SUMMARY_HEADERS', learning.data.courses, {root: true});
      commit('employee_study/coursesBusinessPlusSummary/SET_COURSES_BUSINESS_PLUS_SUMMARY_PAGINATION', learning.data.pagination, {root: true});
      commit('SET_TOTAL_TABS', {key: 'courses_business_plus_summary', value: learning.data.pagination.total});
    },

    async get_courses_verification({commit}, {filter, page = 1, perPage = 10}) {
      const coursesVerification = await api.tests.get_all_assigned_courses({...filter, page, page_size: perPage});

      commit('employee_study/coursesVerification/SET_COURSES_VERIFICATION', coursesVerification.data, {root: true});
      commit('employee_study/coursesVerification/SET_COURSES_VERIFICATION_HEADERS', coursesVerification.data.courses, {root: true});
      commit('employee_study/coursesVerification/SET_COURSES_VERIFICATION_PAGINATION', coursesVerification.data.pagination, {root: true});
      commit('SET_TOTAL_TABS', {key: 'courses_verification', value: coursesVerification.data.pagination.total});
    },

    async make_companies_export({commit}, filter) {
      let export_url = await api.learning.companies_export(filter);
      await commit('SET_EXPORT', export_url.data);
    },

    async make_users_export({commit}, filter) {
      let export_url = await api.learning.users_export(filter);
      await commit('SET_EXPORT', export_url.data);
    },

    async make_courses_export({commit}, filter) {
      let export_url = await api.learning.courses_export(filter);
      await commit('SET_EXPORT', export_url.data);
    },

    async make_courses_summary_export({commit}, filter) {
      let export_url = await api.learning.courses_summary_export(filter);
      await commit('SET_EXPORT', export_url.data);
    },

    async make_courses_business_plus_summary_export({commit}, filter) {
      let export_url = await api.learning.courses_business_plus_summary_export(filter);
      await commit('SET_EXPORT', export_url.data);
    },

    async make_courses_verification_export({commit}, filter) {
      let export_url = await api.tests.get_all_organizations_courses(filter);
      await commit('SET_EXPORT', export_url.data);
    },

    async make_export({getters, commit, dispatch}, filter) {
      let {tab} = filter.tab ? filter : getters;

      await commit('SET_EXPORT_LOADING', true);

      try {
        if (tab === 'organizations') {
          await dispatch('make_companies_export', filter);
        } else if (tab === 'users') {
          await dispatch('make_users_export', filter);
        } else if (tab === 'courses') {
          await dispatch('make_courses_export', filter);
        } else if (tab === 'courses_summary') {
          const summaryTable = getters['coursesSummary/employee_study_courses_summary'];

          await dispatch('make_courses_summary_export', {
            ...filter,
            sort_name     : summaryTable.content.pagination.sortBy || null,
            sort_direction: summaryTable.content.pagination.descending ? 'desc' : 'asc',
            page          : summaryTable.content.pagination.page,
            page_size     : summaryTable.content.pagination.rowsPerPage,
          });
        } else if (tab === 'courses_business_plus_summary') {
          const summaryTable = getters['coursesBusinessPlusSummary/employee_study_courses_business_plus_summary'];

          await dispatch('make_courses_business_plus_summary_export', {
            ...filter,
            sort_name     : summaryTable.content.pagination.sortBy || null,
            sort_direction: summaryTable.content.pagination.descending ? 'desc' : 'asc',
            page          : summaryTable.content.pagination.page,
            page_size     : summaryTable.content.pagination.rowsPerPage,
          });
        } else if (tab === 'courses_verification') {
          const verificationTable = getters['coursesVerification/employee_study_courses_verification'];

          await dispatch('make_courses_verification_export', {
            ...filter,
            sort_name     : verificationTable.content.pagination.sortBy || null,
            sort_direction: verificationTable.content.pagination.descending ? 'desc' : 'asc',
            page          : verificationTable.content.pagination.page,
            page_size     : verificationTable.content.pagination.size,
          });
        }

        await commit('SET_EXPORT_LOADING', false);
      } catch (err) {
        console.error(err);
      }
    },
    async get_learning_stats({getters, commit, dispatch, rootState: {employee_study: {users, organizations}}}, {filter}) {
      let {tab} = filter.tab ? filter : getters;

      try {
        if (tab === 'directorate') {
          await dispatch('get_organizations', filter);
        } else if (tab === 'organizations') {
          const table = organizations.employee_study_org;
          await dispatch('get_companies', {filter, page: table.content.pagination.page, perPage: table.content.pagination.rowsPerPage});
        } else if (tab === 'users') {
          const table = users.employee_study_users;
          await dispatch('get_users', {filter, page: table.content.pagination.page, perPage: table.content.pagination.rowsPerPage});
        } else if (tab === 'courses_summary') {
          await dispatch('get_courses', filter);
        } else if (tab === 'courses_business_plus_summary') {
          await dispatch('get_courses', filter);
        } else if (tab === 'courses_verification') {
          await dispatch('get_courses', filter);
        }
      } catch (err) {
        console.error(err);
      }
    },
  },
};
